/**
 * KAN-906: конец строки фильтров таблицы CRM вместо отдельной полосы "Клиенты N":
 * бейдж числа клиентов (total ответа или число отобранных строк, KAN-880),
 * пояснение "из загруженных", сколько ждут внимания и кнопка
 * "Развернуть"/"Свернуть" (KAN-766). Компонент только рисует.
 */
import { Maximize2, Minimize2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CrmTableCountProps {
  /** null - данные ещё не пришли: бейджей нет, кнопка есть. */
  total: number | null;
  countNote?: string | null;
  attentionCount: number;
  expanded: boolean;
  onToggleFullscreen: () => void;
}

export function CrmTableCount({
  total,
  countNote,
  attentionCount,
  expanded,
  onToggleFullscreen,
}: CrmTableCountProps): JSX.Element {
  const toggleLabel = expanded ? 'Свернуть' : 'Развернуть';
  const ToggleIcon = expanded ? Minimize2 : Maximize2;
  return (
    <div data-testid="crm-table-count" className="ml-auto flex shrink-0 items-center gap-1.5">
      {total !== null && (
        <span
          data-testid="crm-count"
          title="Клиентов"
          aria-label={`Клиентов: ${total}`}
          className="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold tabular-nums text-gray-600"
        >
          {total}
        </span>
      )}
      {total !== null && countNote && (
        <span data-testid="crm-count-note" className="whitespace-nowrap text-xs text-gray-500">
          {countNote}
        </span>
      )}
      {attentionCount > 0 && (
        <span
          data-testid="crm-attention-count"
          title="Требуют внимания"
          className="whitespace-nowrap rounded-full bg-rose-600 px-2 py-0.5 text-xs font-semibold text-white"
        >
          {attentionCount} ждут
        </span>
      )}
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-8 w-8 text-gray-500"
        aria-label={toggleLabel}
        title={toggleLabel}
        aria-pressed={expanded}
        data-testid="crm-fullscreen-toggle"
        onClick={onToggleFullscreen}
      >
        <ToggleIcon className="h-4 w-4" />
      </Button>
    </div>
  );
}
